import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';
import { handlePendingImport } from './lib/pendingImport';

// Resolve any /to → PWA hand-off (and replaceState to the detail URL) before
// mounting so the router renders the right route on first paint. Avoiding
// top-level await keeps the Vite default browser target (Safari 14, etc).
handlePendingImport().then(() => {
  mount(App, {
    target: document.getElementById('app')!,
  });
});
